const DataService = (() => {
    // const BASE_URL = process.env.REACT_APP_API_ROOT;
    const BASE_URL = 'https://economics.mapfre.com/api/v1/rankings';

    const EUROPE_RECORDS = BASE_URL + '/europe/records';
    const LATAM_RECORDS = BASE_URL + '/latam/records';
    const LATAM_HERFINDAHL_RECORDS = BASE_URL + '/latam/herfindahl_records';
    const LATAM_CONCENTRATION_RECORDS = BASE_URL + '/latam/concentration_records';

    const URLS_TO_FETCH = [EUROPE_RECORDS, LATAM_RECORDS, LATAM_HERFINDAHL_RECORDS, LATAM_CONCENTRATION_RECORDS];

    const fetchUrlData = (url: string) => ( fetch(url).then((res) => res.json()) );

    const fetchInitialData = async () => {
        return Promise.all(URLS_TO_FETCH.map((url: string) => {
            return fetchUrlData(url);
        }))
        .then((apiData) => {
            return {
              europeRecords: apiData[0],
              latamRecords: apiData[1],
              latamHerfindahlRecords: apiData[2],
              latamConcentrationRecords: apiData[3]
            };
        })
    };

    return {
        fetchInitialData: () => fetchInitialData()
    }
})();

export default DataService;
